module.exports = "<div class=\"preview-waiting\">\n    <core-helpers-box-loading ></core-helpers-box-loading>\n</div>\n"